import { openDB } from "idb";

const DB_NAME = "sales_offline_db";
const STORE_NAME = "offline_sales";

export const initDB = async () => {
  return openDB(DB_NAME, 1, {
    upgrade(db) {
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME, { keyPath: "id", autoIncrement: true });
      }
    },
  });
};

export const saveOfflineSale = async (sale: any) => {
  const db = await initDB();
  await db.add(STORE_NAME, sale);
};

export const getOfflineSales = async () => {
  const db = await initDB();
  return await db.getAll(STORE_NAME);
};

export const clearOfflineSales = async () => {
  const db = await initDB();
  await db.clear(STORE_NAME);
};
